import React, { useState } from "react";
import './HeaderLogin.scss';
import { CustomerLoginEmail, CustomerLoginPhone } from "../../api/Auth";

interface ModalLoginProps {
    onClose: () => void;
    onLoginSuccess: () => void;
    onOpenForgotPassword: () => void;
    onOpenSignup: () => void;
}

export default function ModalLogin({ onClose, onLoginSuccess, onOpenForgotPassword, onOpenSignup }: ModalLoginProps) {
    const [loginMethod, setLoginMethod] = useState<"email" | "phone">("email");
    const [credential, setCredential] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrorMessage("");

        try {
            const resp = loginMethod === "phone"
                ? await CustomerLoginPhone(credential, password)
                : await CustomerLoginEmail(credential, password);

            if (resp.status) {
                onLoginSuccess();
                onClose();
            } else {
                setErrorMessage(resp.msg || "Đăng nhập thất bại");
            }
        } catch (error) {
            setErrorMessage("Có lỗi xảy ra, vui lòng thử lại.");
        }
    };

    return (
        <div
            role="presentation"
            className="styles_modalItem__YKbSY"
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
            }}
        >
            {/* BACKDROP */}
            <div
                onClick={onClose}
                aria-hidden="true"
                style={{
                    zIndex: -1,
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    WebkitTapHighlightColor: "transparent",
                }}
            />

            <div tabIndex={0} data-test="sentinelStart" />

            {/* MODAL CONTENT */}
            <div
                className="styles_auth_modal_content__gD2DP"
                tabIndex={-1}
                style={{ width: 460 }}
            >
                {/* HEADER */}
                <div className="MuiGrid-root styles_auth_modal_header__8MVV9 MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-10">
                        <header className="styles_auth_modal_title__7Ht8G">
                            <div className="styles_paddingLeft__o43dz">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='40' height='40'/%3e"
                                            style={{ display: "block" }}
                                        />
                                    </span>

                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/thuocsi_short.svg?v=1"
                                        data-origin-url="https://cdn-web-next.thuocsi.vn/thuocsi_short.svg?v=1"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            margin: "auto",
                                            display: "block",
                                            minWidth: "100%",
                                            minHeight: "100%",
                                        }}
                                    />
                                    <noscript />
                                </span>

                                <span>Đăng nhập</span>
                            </div>
                        </header>
                    </div>

                    {/* CLOSE BUTTON */}
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-1">
                        <button
                            className="MuiButtonBase-root MuiIconButton-root styles_auth_modal_close__CfXli"
                            type="button"
                            aria-label="close"
                            onClick={onClose}
                        >
                            <span className="MuiIconButton-label">
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                            <span className="MuiTouchRipple-root" />
                        </button>
                    </div>
                </div>

                {/* BODY */}
                <div className="styles_auth_modal_body__le_XM">
                    <div className="styles_containerForm__OWa_F">
                        <form onSubmit={handleSubmit}>
                            {errorMessage && (
                                <div style={{ color: 'red', marginBottom: '10px', textAlign: 'center' }}>
                                    {errorMessage}
                                </div>
                            )}
                            {/* USERNAME */}
                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root styles_input__tsrT1 MuiInputBase-adornedStart MuiOutlinedInput-adornedStart">
                                    <span className="styles_adornmentIcon__93YYO">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 6H4C2.53267 6 2 7.196 2 8V16C2 17.4673 3.196 18 4 18H20C21.4673 18 22 16.804 22 16V8C22 6.53267 20.804 6 20 6ZM20.6667 15.992C20.6587 16.3 20.5373 16.6667 20 16.6667H4.008C3.7 16.6587 3.33333 16.5373 3.33333 16V8.008C3.34133 7.7 3.46333 7.33333 4 7.33333H19.992C20.3 7.34133 20.6667 7.46333 20.6667 8V15.992ZM7.33333 14H16.6667V15.3333H7.33333V14ZM18 14H19.3333V15.3333H18V14ZM18 11.3333H19.3333V12.6667H18V11.3333ZM15.3333 11.3333H16.6667V12.6667H15.3333V11.3333ZM14 12.6667H12.6667V11.3333H14V12.6667ZM11.3333 12.6667H10V11.3333H11.3333V12.6667ZM8.66667 12.6667H7.33333V11.3333H8.66667V12.6667ZM4.66667 11.3333H6V12.6667H4.66667V11.3333ZM4.66667 14H6V15.3333H4.66667V14ZM18 8.66667H19.3333V10H18V8.66667ZM15.3333 8.66667H16.6667V10H15.3333V8.66667ZM14 10H12.6667V8.66667H14V10ZM11.3333 10H10V8.66667H11.3333V10ZM8.66667 10H7.33333V8.66667H8.66667V10ZM4.66667 8.66667H6V10H4.66667V8.66667Z" fill="#3D3D8D"></path></svg>
                                    </span>

                                    <input
                                        name={loginMethod === "phone" ? "phone" : "email"}
                                        placeholder={loginMethod === "phone" ? "Nhập số điện thoại *" : "Nhập Email *"}
                                        type={loginMethod === "phone" ? "tel" : "email"}
                                        className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedStart"
                                        autoComplete="off"
                                        value={credential}
                                        onChange={(e) => setCredential(e.target.value)}
                                        required
                                    />

                                    <fieldset className="jss439 MuiOutlinedInput-notchedOutline">
                                        <legend className="jss440" style={{ width: "0.01px" }} />
                                    </fieldset>
                                </div>
                            </div>

                            <div className="styles_blockMargin__4ZH18" />

                            {/* PASSWORD */}
                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root styles_input__tsrT1 MuiInputBase-adornedStart MuiOutlinedInput-adornedStart MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                    <span className="styles_adornmentIcon__93YYO">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M14.6542 3.6001C11.488 3.6001 8.90683 6.18122 8.90683 9.34747C8.90683 9.73756 8.98762 10.1005 9.06225 10.4648L3.79585 15.7312C3.67148 15.8556 3.6016 16.0242 3.60156 16.2001V19.7369C3.60158 19.9128 3.67145 20.0815 3.79582 20.2058C3.92018 20.3302 4.08885 20.4001 4.26472 20.4001H7.80156C7.97744 20.4001 8.1461 20.3302 8.27047 20.2058C8.39483 20.0815 8.4647 19.9128 8.46472 19.7369V18.6317H10.0121C10.188 18.6317 10.3566 18.5618 10.481 18.4374C10.6054 18.3131 10.6752 18.1444 10.6752 17.9685V16.4211H12.2226C12.3985 16.4211 12.5672 16.3513 12.6915 16.2269C12.8159 16.1025 12.8858 15.9339 12.8858 15.758V14.7831C13.4478 14.9664 14.0333 15.0948 14.6542 15.0948C17.8204 15.0948 20.4016 12.5137 20.4016 9.34747C20.4016 6.18122 17.8204 3.6001 14.6542 3.6001ZM14.6542 4.92641C17.1036 4.92641 19.0752 6.89809 19.0752 9.34747C19.0752 11.7968 17.1036 13.7685 14.6542 13.7685C13.886 13.7685 13.1684 13.5742 12.5404 13.2314C12.4394 13.1763 12.3258 13.1484 12.2108 13.1505C12.0957 13.1526 11.9832 13.1845 11.8843 13.2432C11.7853 13.3019 11.7033 13.3854 11.6464 13.4853C11.5895 13.5853 11.5595 13.6984 11.5595 13.8134V15.0948H10.0121C9.83621 15.0949 9.66755 15.1647 9.54318 15.2891C9.41882 15.4135 9.34895 15.5821 9.34893 15.758V17.3054H7.80156C7.62569 17.3054 7.45702 17.3753 7.33266 17.4996C7.2083 17.624 7.13842 17.7926 7.1384 17.9685V19.0738H4.92788V16.4747L10.228 11.1746C10.3111 11.0915 10.3706 10.9879 10.4005 10.8742C10.4304 10.7606 10.4295 10.6411 10.3981 10.5279C10.2923 10.1473 10.2331 9.75405 10.2331 9.34747C10.2331 6.89809 12.2048 4.92641 14.6542 4.92641ZM15.5384 7.13694C15.1866 7.13694 14.8493 7.27668 14.6006 7.52541C14.3518 7.77414 14.2121 8.11149 14.2121 8.46326C14.2121 8.81502 14.3518 9.15237 14.6006 9.4011C14.8493 9.64983 15.1866 9.78957 15.5384 9.78957C15.8902 9.78957 16.2275 9.64983 16.4762 9.4011C16.725 9.15237 16.8647 8.81502 16.8647 8.46326C16.8647 8.11149 16.725 7.77414 16.4762 7.52541C16.2275 7.27668 15.8902 7.13694 15.5384 7.13694Z" fill="#3D3D8D"></path></svg>
                                    </span>

                                    <input
                                        name="password"
                                        placeholder="Nhập mật khẩu *"
                                        className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedStart MuiOutlinedInput-inputAdornedEnd"
                                        autoComplete="off"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />

                                    <div className="MuiInputAdornment-root MuiInputAdornment-positionEnd">
                                        <button
                                            className="MuiButtonBase-root MuiIconButton-root"
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <span className="MuiIconButton-label">
                                                {showPassword ? (
                                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"></path></svg>
                                                ) : (
                                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"></path></svg>

                                                )}
                                            </span>
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </div>

                                    <fieldset className="jss439 MuiOutlinedInput-notchedOutline">
                                        <legend className="jss440" style={{ width: "0.01px" }} />
                                    </fieldset>
                                </div>
                            </div>

                            {/* ACTIONS */}
                            <div
                                className="styles_forgetPasswordContainer__7oi_P"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onOpenForgotPassword();
                                }}

                            >
                                <span className="styles_forgetPassword__gyZLr" style={{ cursor: 'pointer' }}>
                                    Quên mật khẩu?
                                </span>
                            </div>

                            <button className="MuiButtonBase-root styles_btnLogin__kuq6I" type="submit">
                                <span>Đăng Nhập</span>
                                <span className="MuiTouchRipple-root" />
                            </button>

                            <div className="styles_hrContainer__CkWQX d-none">
                                <hr className="styles_hrLine__xYMYw" />
                                <span className="styles_orKeyword__74x0z">hoặc</span>
                            </div>

                            <button
                                className="MuiButtonBase-root styles_btnLoginOtp__t4cHS d-none"
                                type="button"
                                onClick={() => {
                                    setLoginMethod((prev) => (prev === "email" ? "phone" : "email"));
                                    setCredential("");
                                    setErrorMessage("");
                                }}
                            >
                                <span>
                                    {loginMethod === "email" ? "Đăng nhập bằng số điện thoại" : "Đăng nhập bằng email"}
                                </span>
                                <span className="MuiTouchRipple-root" />
                            </button>

                            <p className="styles_registerContainer__ryTI1">
                                Để nhận Ưu đãi hấp dẫn,{" "}
                                <button
                                    type="button"
                                    className="styles_linkLogin__dVwbX"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onOpenSignup();
                                    }}
                                >
                                    Đăng ký thành viên
                                </button>
                            </p>
                        </form>
                    </div>
                </div>
            </div>

            <div tabIndex={0} data-test="sentinelEnd" />
        </div>
    );
}